/**
 * GlobalUpsellHandler — écoute l'event `clarix:upsell` dispatché par l'axios
 * interceptor lorsqu'un 403 "Fonctionnalité non incluse" arrive.
 *
 * Monté une seule fois dans le layout principal → chaque 403 upsell affiche
 * un dialog de conversion propre.
 */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UpsellDialog from "./UpsellDialog";

export default function GlobalUpsellHandler() {
  const [feature, setFeature] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (e) => {
      const f = e.detail?.feature;
      if (f) setFeature(f);
    };
    window.addEventListener("clarix:upsell", handler);
    return () => window.removeEventListener("clarix:upsell", handler);
  }, []);

  const close = () => setFeature(null);
  const goToPlan = () => {
    close();
    navigate("/app/plan");
  };

  return (
    <UpsellDialog
      open={!!feature}
      onOpenChange={(o) => !o && close()}
      feature={feature}
      included={false}
      onGoToPlan={goToPlan}
    />
  );
}
